<template>
    <div style="position: relative;lefr:0;top:0;">
        <div style="position: absolute;lefr:0;top:0;z-index:10;padding-top: 80px;" class="my-body">
        <div class="border-div" style="border-radius:6px 6px 0 0;">
            <div class="head-title flex jus-con-center ali-ite-center">
                单程
            </div>
            <div class="outside-div flex jus-con-between ali-ite-center">
                <div class="start-place" @click="selectPlace('departCity','')"><span>{{departCityString}}</span></div>
                <img class="change-img-btn" src="../../../assets/flights/flights-zh-img.png" @click="changeDepartAndArrive()" />
                <div class="end-place" @click="selectPlace('arriveCity','')"><span>{{arriveCityString}}</span></div>
            </div>
            <div class="outside-div flex jus-con-start ali-ite-end" @click="calendarShowFunc">
                <div class="date-div">{{dateTimeString}}</div>
                <div class="date-title-div">{{dateTimeTab}}</div>
            </div>
            <!-- <div class="outside-div flex jus-con-between ali-ite-center" @click="typeShowFunc">
                <div class="type-div">{{flightsType[type]['name']}}</div>
                <div class="flex jus-con-end ali-ite-center">
                    <img style="width:0.8em;height:0.8em;" src="../../../assets/flights/o_icon_Expand_right2_20px_@2x.m.png" />
                </div>
            </div> -->
        </div>
        <img class="bg-img-other" src="../../../assets/flights/bg-img-1.png" />
        <div  class="border-div"  style="border-radius: 0 0 6px 6px;">
            <div class="outside-div flex jus-con-center ali-ite-center" style="border-bottom:none;">
                <div class="button-div red-bg-color" style="width:calc( 100% - 40px );" @click="searchConfirm">搜索</div>
            </div>
        </div>
        <div>
            <div class="history-div history-head flex jus-con-between ali-ite-center">
                <div>历史记录</div>
                <div class="flex jus-con-end ali-ite-center" @click="sessionStorageMoveAll"><img class="clear-img-class " src="../../../assets/flights/clear.png" /> <div style="color:#3377ff;">清除全部</div></div>
            </div>
            <div class="history-div flex jus-con-start ali-ite-center flex-warp" style="margin-top:0;">
                <div class="history-item flex jus-con-center ali-ite-center" v-for="(item ,index) in history" :key="index">
                    <div @click="changeCity(index)">{{item.departCityString}}-{{item.arriveCityString}}</div>
                </div>
            </div>
        </div>
        </div>
        <city-search-page v-if="searchShow"  :style="{position: 'absolute',lefr:0,top:0,zIndex:searchIndex}" @cancel="hideSearchPge" :mainData="mainData" @changeCity="changeCityByTabString" :otherCity="otherCity"></city-search-page>
        <div class="calendar-border-div" v-show="calendarShow">
            <div class="calendar-border-body">
                <div class="cale-head">
                    <div>日期选择</div>
                    <img class="cale-cancel-img" src="../../../assets/flights/o_icon_close1_32px_@2x.png" @click="calendarHide" />
                </div>
                <div style="width:100%;height( 100% - 2em );">
                    <jlkj-calendar @confirm="calendarConfirm"  v-model="theDateArray"></jlkj-calendar>
                </div>
            </div>
        </div>
        <div v-show="gotoLoading" class="the-loading-border">
            <van-loading color="#3377ff" />
        </div>
        <div class="type-border-div" v-show="typeShow">
            <div class="type-border-body" style="border-radius:10px 10px 0 0 ;">
                <div class="cale-head">
                    <div>选择舱位</div>
                    <img class="cale-cancel-img" src="../../../assets/flights/o_icon_close1_32px_@2x.png" @click="typeHide" />
                </div>
                <div style="width:100%;height( 100% - 2em );">
                    <div class="flex jus-con-between ali-ite-center margin-top-bot-30" v-for="(item ,index) in flightsType" :key="index">
                        <div :class="{'blue-color':(type===index?true:false)}">{{item.name}}</div>
                        <div><jlkj-radio v-model="item.checked"  @change="theRadioList" :groupIndex="index+''" ></jlkj-radio></div>
                    </div>
                </div>
            </div>
        </div>

        <jlkj-popup ref="popup" v-show="windowShow" :message="thisMessage" :type="windowType"></jlkj-popup>
    </div>
</template>
<script>
import jlkjCalendar from '../../../components/jlkj-calendar.vue'
import jlkjIndexBar from '../../../components/jlkj-index-bar.vue'
import jlkjRadio from '../../../components/jlkj-radio.vue'

import JlkjPopup from '../../../components/jlkj-popup.vue'
import CitySearchPage from '../../../components/city-search-page.vue'
import {new_Date} from '../../../utils/new_date'

let localStorageGet=function(itemName){
            return localStorage.getItem(itemName);
        }
export default {
    components: { jlkjCalendar, jlkjIndexBar, CitySearchPage , jlkjRadio , JlkjPopup},
    data(){
        return{
            windowType:'center',
            windowShow:false,
            thisMessage:'',
            theDateArray:[],
            departCityString:'',
            departCity:'',
            arriveCityString:'',
            arriveCity:'',
            searchShow:false,
            searchIndex:1,
            placeKeyString:'',
            otherCity:'',
            mainData:[],
            calendarShow:false,
            dateTime:[],
            dateTimeString:'',
            dateTimeNumString:'',
            dateTimeTab:'',
            history:'',
            gotoLoading:false,
            typeShow:false,
            flightsType:[
                        {name:'不限舱位',checked:true},
                        {name:'经济舱',checked:false},
                        {name:'头等/公务舱',checked:false},
                    ],
            type:0,
            flightsTypeString:'不限舱位'
        }
    },
    created(){
        this.initDateTime();
    },
    mounted(){
        this.init();
    },
    methods:{
        theRadioList:function(value,indexString){
            let index=parseInt(indexString);
            this.type=index;
            for(let i=0;i<this.flightsType.length;i++){
               if(i===index){
                   this.flightsType[i].checked=value;
                   this.flightsTypeString=this.flightsType[i].name;
               }else{
                    if(value){
                        this.flightsType[i].checked=false;
                    }
               }
            }
            this.typeShow=false;
        },
        initDateTime:function(){
            let nowDate=new_Date();
            let endDate=new_Date();
            endDate.setFullYear(nowDate.getFullYear()+1);
            this.dateTimeString=(nowDate.getMonth()+1)+'月'+nowDate.getDate()+'日';
            this.dateTimeNumString=nowDate.getFullYear()+'-'+
            ((nowDate.getMonth()+1)>9?''+(nowDate.getMonth()+1):'0'+(nowDate.getMonth()+1))+'-'+
            (nowDate.getDate()>9?nowDate.getDate()+'':'0'+nowDate.getDate());
            this.dateTimeTab='今天';
            this.theDateArray=[nowDate.getFullYear(),nowDate.getMonth()+1,nowDate.getDate(),endDate.getFullYear(),endDate.getMonth()+1,endDate.getDate()]

        },
        init:function(){
          this.history=JSON.parse(localStorageGet('flightsHistory'));
            if (this.history && this.history.length > 0) {
              this.departCityString = this.history[0].departCityString;
              this.departCity = this.history[0].departCity;
              this.arriveCityString = this.history[0].arriveCityString;
              this.arriveCity = this.history[0].arriveCity;
            }

            this.$API.flights.getCityList()
            .then((res)=>{
                if(res.code===200){
                    let tempData=[];
                    tempData.push({str:'热门城市',key:'HOT',value:res.data.hotList});
                    tempData.push(...res.data.groupList);
                    this.mainData=tempData;
                    sessionStorage.setItem('cityMainData',JSON.stringify(this.mainData));

                    if (!this.departCity || !this.arriveCity) {
                      let locationCity = null;
                      try {
                        locationCity = JSON.parse(sessionStorage.getItem("city"));
                      } catch (error) {
                        console.debug(error.message);
                      }
                      if (locationCity) {
                        const cityName = locationCity[1].name;
                        const departCity = res.data.groupList.reduce((sum, curr) => {
                          sum.push(...curr.value);
                          return sum;
                        }, []).find(city => cityName.includes(city.areaShortName));
                        if (departCity) {
                          this.departCityString = departCity.areaShortName;
                          this.departCity = departCity.iataCode;
                          const arriveCity = res.data.hotList.find(city => city.areaShortName !== departCity.areaShortName);
                          if (arriveCity) {
                            this.arriveCityString = arriveCity.areaShortName;
                            this.arriveCity = arriveCity.iataCode;
                            return;
                          }
                        }
                      }
                      this.departCityString = res.data.hotList[0].areaShortName;
                      this.departCity = res.data.hotList[0].iataCode;
                      this.arriveCityString = res.data.hotList[1].areaShortName;
                      this.arriveCity = res.data.hotList[1].iataCode;
                    }
                }else{
                  this.$toast(res.msg || '请求机场数据时出错');
                }
            })
            .catch((err)=>{
                this.thisMessage='网络请求错误，请稍后重试';
                this.windowShow=true;
                this.$refs['popup'].readyHide(()=>{this.windowShow=false;});
            })
        },
        selectPlace:function(placeType,otherCity){
            this.searchIndex=20;
            this.searchShow=true;
            this.placeKeyString=placeType;
            this.otherCity=otherCity;
        },
        changeDepartAndArrive:function(){
            let tempCityString=this.departCityString;
            let tempCity=this.departCity;
            this.departCityString=this.arriveCityString;
            this.departCity=this.arriveCity;
            this.arriveCityString=tempCityString;
            this.arriveCity=tempCity;
        },
        changeCityByTabString:function(cityString,city){
            this[this.placeKeyString+'String']=cityString;
            this[this.placeKeyString]=city;
            this.searchShow=false;
        },
        hideSearchPge:function(){
            this.searchShow=false;
        },
        calendarConfirm:function(time){
            this.dateTime=time[0];

            let dateObj=time[0].split('-');
            let nowDate=new_Date()
            let isNowYear=nowDate.getFullYear().toString()===dateObj[0]?true:false;
            // console.log(nowDate.getFullYear(),dateObj[0]);
            let theDay=(Date.parse(new_Date(time[0]))-Date.parse(nowDate)) / (1000*60*60*24);
            this.dateTimeString=(isNowYear?'':(dateObj[0]+'年'))+dateObj[1]+'月'+dateObj[2]+'日';
            this.dateTimeNumString=dateObj[0]+'-'+dateObj[1]+'-'+dateObj[2];
            this.dateTimeTab='';
            if(theDay<=2){
                this.dateTimeTab='后天';
            }
            if(theDay<=1){
                this.dateTimeTab='明天';
            }
            if(theDay<=0){
                this.dateTimeTab='今天';
            }
            console.log(time,'time')
            this.calendarHide();
        },
        calendarHide:function(){
            this.calendarShow=false;
        },
        calendarShowFunc:function(){
            this.calendarShow=true;
        },
        typeHide:function(){
            this.typeShow=false;
        },
        typeShowFunc:function(){
            this.typeShow=true;
        },
        sessionStorageAdd:function(departCity,arriveCity,departCityString,arriveCityString){
            let flightsHistotyJson=JSON.parse(localStorageGet('flightsHistory')===null?'[]':localStorageGet('flightsHistory'));
            for(let key=0 ;key< flightsHistotyJson.length;key++){
                if(flightsHistotyJson[key].departCity===departCity&&flightsHistotyJson[key].arriveCity===arriveCity){
                    flightsHistotyJson.splice(key,1);
                    break;
                }
            }
            flightsHistotyJson=flightsHistotyJson!==null?flightsHistotyJson:[];
            // console.log(flightsHistotyJson,"eeeeee");
            flightsHistotyJson.unshift({departCity:departCity,arriveCity:arriveCity,departCityString:departCityString,arriveCityString:arriveCityString})
            localStorage.setItem('flightsHistory',JSON.stringify(flightsHistotyJson));
        },
        sessionStorageMoveAll:function(){
            localStorage.setItem('flightsHistory','[]');
            this.history=JSON.parse(localStorageGet('flightsHistory'));
        },
        searchConfirm:function(){
          if (this.departCity === this.arriveCity) {
            this.$toast('出发地与到达地不能是同一座城市');
            return;
          }
            this.sessionStorageAdd(this.departCity,this.arriveCity,this.departCityString,this.arriveCityString);
            this.gotoLoading=true;
            this.$router.push({
                path: './flights-query-result' ,
                query:{
                    departCity:this.departCityString,
                    arriveCity:this.arriveCityString,
                    from:this.departCity,
                    to:this.arriveCity,
                    startDate:this.dateTimeNumString,
                    type:this.type
                    }
                });
        },
        changeCity:function(index){
            this.departCityString=this.history[index].departCityString;
            this.departCity=this.history[index].departCity;
            this.arriveCityString=this.history[index].arriveCityString;
            this.arriveCity=this.history[index].arriveCity;

            this.windowType='center';
            this.thisMessage='已切换到:'+this.departCityString+'-'+this.arriveCityString;
            this.windowShow=true;
            this.$refs['popup'].readyHide(()=>{this.windowShow=false;})
        },
        new_Date
    }
}
</script>
<style scoped>
    .bg-img-other{
        width:calc( 100% - 40px );
        margin: 0 20px;
        display: block;
    }
    .my-body{
        background-image: url("../../../assets/flights/bg-img-2.png");
        background-size: 100vw auto;
        background-repeat: no-repeat;
        background-color: #F9FAFC;
        min-height:100vh;
        box-sizing: border-box;
    }
    .button-div{
        height: 44px;
        padding:0.25em 1em;
        box-sizing: border-box;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        background: linear-gradient(270deg, #4380FF 0%, #427FFF 100%);
        box-shadow: 0px 10px 20px 0px rgba(66, 127, 255, 0.27);
        border-radius: 22px;
    }
    .red-bg-color{
        background-color:crimson;
    }
    .flex{
        display: flex;
    }
     .jus-ite-center{
        justify-items: center;
    }
    .jus-ite-start{
        justify-items: flex-start;
    }
    .jus-ite-between{
        justify-items: space-between;
    }
    .jus-con-center{
        justify-content: center;
    }
    .jus-con-start{
        justify-content: flex-start;
    }
    .jus-con-between{
        justify-content: space-between;
    }
    .ali-ite-start{
        align-items: flex-start;
    }
    .ali-ite-center{
        align-items:center;
    }
    .ali-ite-end{
        align-items: flex-end;
    }
    /******************************************* */
    .tab-btn-span{
        padding:10px auto;
        width:50%;
    }
    .tab-text{
        font-size: 1.5rem;
    }
    .tab-line{
        background-color: crimson;
        height: 4px;
        width:3rem;
        border-radius: 2px;
    }
    .border-div{
        width:calc( 100% - 40px );
        margin:0 20px;
        background: #FFFFFF;
    }
    .outside-div{
        padding: 15px 0;
        margin:0 20px;
        box-sizing: border-box;
        border-bottom: 1px solid rgb(240,240,240);
    }
    .start-place,.end-place{
        font-size: 18px;
        font-weight: bold;
        color: #2E3033;
        width:calc( ( 100% - 2em ) / 2 );
    }
    .start-place{
        display: flex;
        justify-content: flex-start;
    }
    .end-place{
        display: flex;
        justify-content: flex-end;
    }
    .change-img-btn{
        width: 2em;
        height: 2em;
    }
    .date-div{
        font-size: 18px;
        font-weight: bold;
        color: #2E3033;
    }
    .date-title-div{
        padding: 0.15em;
        font-size: 12px;
        font-weight: 500;
        color: #8A8F99;
        margin-left:1em;
    }
    .carry{
        margin-left: 20px;
    }
    .head-title{
        background: #DBE7FF;
        border-radius: 6px 6px 0 0 ;
        padding:15px 0;
        font-size: 15px;
        font-weight: bold;
        color: #2E3033;
    }
    .border-div > div:last-child{
        border-bottom:0;
    }
    .type-div{
        font-size: 15px;
        font-weight: bold;
        color: #2E3033;
        line-height: 21px;
    }
    .clear-img-class{
        width:13px;
        height: 13px;
    }
    .history-div{
        margin:20px 20px 0px 20px;
        width:calc( 100% - 40px );
    }
    .history-item{
        height: 30px;
        background: #F0F2F7;
        border-radius: 15px;
        width:calc( ( 100% - 40px )  / 3 );
        margin-right:20px;
        margin-top:20px;
        font-size: 13px;
        font-weight: 500;
        color: #5C5F66;
    }
    .history-item:nth-child(3n){
        margin-right: 0;
    }
    .flex-warp{
        flex-wrap: wrap;
    }
    .history-head{
        font-size: 13px;
        font-weight: 500;
        color: #2E3033;
    }
    .calendar-border-div{
        width: 100vw;
        height: 100vh;
        position: fixed;
        left:0;
        top:0;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        background: rgba(0,0,0,0.5);
    }
    .calendar-border-body{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
    }

    .type-border-div{
        width: 100vw;
        height: 100vh;
        position: fixed;
        left:0;
        top:0;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        background: rgba(0,0,0,0.5);
    }
    .type-border-body{
        width: 100%;
        height: auto;
        background: #FFFFFF;
    }

    .cale-head{
        width:100%;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        left: 0;
        top:0;
    }
    .cale-cancel-img{
        height: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position:absolute;
        right: 0;
        top:0;
        width:1rem;
        margin:0.5rem 0;
        margin-right:15px;
    }
    .the-loading-border{
        height: 100vh;
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        left:0;
        top:0;
        background:rgba(0,0,0,0.5);
    }
    .margin-top-bot-30{
        margin:30px 20px;
        width: calc( 100% - 40px );
        font-size: 15px;
        font-weight: bold;
        color: #2E3033;
    }
    .blue-color{
        color: #3377ff;

    }
    .calendar-border-div,.type-border-div{
        z-index: 20;
    }
    .the-loading-border{
        z-index: 120;
    }
</style>
